import { h } from "preact";
import { formatPriceWithSymbol } from "../../tools";

export default function DebtBanner({
  accountId,
  banners,
  onPay,
  onClose,
  disabled,
  price,
  priceWithoutFormat,
  onCompensationClick,
}) {
  const matched = banners.filter((b) => b.key === String(accountId));

  if (!matched.length) {
    return null;
  }

  return matched.map((banner) => (
    <div className="custom-banner content test" key={banner.key}>
      <div class="warning page__warning" id="page-warning" role="alert">
        <div class="container page-warning__container">
          <div class="page-warning__content">
            <div dangerouslySetInnerHTML={{ __html: banner.value }} />
          </div>
          <button class="warning__close-button js__close-warning" onClick={onClose}>
            <svg
              width="24"
              height="24"
              viewbox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="black"
              ></path>
            </svg>
          </button>
        </div>
      </div>
      <div className="debt-table-item-2__button-container">
        {Number(priceWithoutFormat) > 0 && (
          <button
            className={`button-primary ${disabled ? "disabled" : ""}`}
            onClick={onPay}
            disabled={disabled}
          >
            Оплатить {price}
          </button>
        )}
        {Number(banner.compensation) > 0 && (
          <button
            className="button-primary"
            onClick={onCompensationClick}
          >
            Компенсация {formatPriceWithSymbol(banner.compensation)}
          </button>
        )}
      </div>
    </div>
  ));
}
